<template>
    <div>
        <p v-if="!hasError">Initializing...</p>
        <p v-else>Error occurs. Please try again.</p>
    </div>
</template>

<script>
    import {Vue, Component} from 'vue-property-decorator'
    import {UserAgentApplication, AuthError, AuthenticationParameters} from 'msal';
    import axios from 'axios';
    import store from "../store";

    /**
     * Class-component
     */
    @Component
    export default class Auth extends Vue {
        accessToken = null;
        authenticated = false;
        hasError = false;
        async mounted() {
            const msalConfig = {
                auth: {
                    authority: 'https://login.microsoftonline.com/e3b48527-4cbe-42a2-b4d2-11b3cc7a86fc',
                    clientId: '36d7e726-665d-4954-996d-3d1492a66fa1'
                }
            };

            const msalInstance = new UserAgentApplication(msalConfig);

            msalInstance.handleRedirectCallback(() => { // on success
                this.authenticated = true
            }, (authErr) => {  // on fail
                console.log(authErr);
                // this.hasError = true
                // this.errorMessage = authErr.errorMessage
            });

            // not logged in, perform full page redirect
            if (!msalInstance.getAccount()) {
                msalInstance.loginRedirect({});
            } else {
                this.authenticated = true
            }

            const accessTokenRequest = {
                scopes: ["user.read", "Directory.Read.All", "Files.ReadWrite.All"]
            }

            try {
                const accessTokenResponse = await msalInstance.acquireTokenSilent(accessTokenRequest)
                this.accessToken = accessTokenResponse.accessToken;
            } catch (e) {
                //Acquire token silent failure, and send an interactive request
                console.log(e);
                msalInstance.acquireTokenRedirect(accessTokenRequest);
            }



            if (this.accessToken) {
                Vue.prototype.$msal = msalInstance
                // get user data
                try {
                    const me = await axios.get('https://graph.microsoft.com/v1.0/me', {
                        headers: {
                            'Authorization': `Bearer ${this.accessToken}`
                        }
                    })
                    this.$store.commit('addUser', me.data)
                    await this.$store.dispatch('addStaffId')

                    const groupId = "aea7cf90-b962-4aa1-a5aa-16cfb8322d39";
                    const admin = await axios.post('https://graph.microsoft.com/v1.0/me/checkMemberObjects', {
                            "ids": [groupId]
                    }, {
                        headers: {
                            'Authorization': `Bearer ${this.accessToken}`
                        }
                    })
                    if (admin.data.value.length) {
                        this.$store.commit('updateAdmin')
                    }
                } catch (e) {
                    console.log(e)
                    this.hasError = true
                }
                this.$router.go(-1)
            }
        }
    }
</script>

<style scoped>

</style>
